import React from 'react';
import moment from 'moment';
import {useIntl} from 'react-intl';

import PropTypes from 'prop-types';
import {List, Avatar, Modal, Comment, Tooltip} from 'antd';
import './MessageItem.less';

const MessageItem = (props) => {
  const {item} = props;
  const intl = useIntl();

  const onDetail = () => {
    Modal.info({
      title: intl.messages['common.detail'],
      content: (
        <Comment
          author={item.name}
          avatar={<Avatar src={item.image} alt={item.name} />}
          content={
            <p>
              <div
                dangerouslySetInnerHTML={{
                  __html: item.message,
                }}
              />
            </p>
          }
          datetime={
            <Tooltip title={item.time}>
              <span>{moment(item.time, 'DD/MM/YYYY HH:mm:ss').fromNow()}</span>
            </Tooltip>
          }
        />
      ),
      onOk() {},
    });
  };

  return (
    <List.Item className='message-list-item item-hover'>
      <Avatar className='message-avatar' src={item.image} />
      <div className='message-list-item-content'>
        <h3 onClick={() => onDetail()}>
          {item.name} - {moment(item.time, 'DD/MM/YYYY HH:mm:ss').fromNow()}
        </h3>
        <p onClick={() => onDetail()}>
          <div
            dangerouslySetInnerHTML={{
              __html: item.message,
            }}
          />
        </p>
      </div>
    </List.Item>
  );
};

export default MessageItem;

MessageItem.propTypes = {
  item: PropTypes.object.isRequired,
};
